// extracted by mini-css-extract-plugin
module.exports = {"providerGroup":"providerGroup__3GZeZ","providerGroupKey":"providerGroupKey__2CarK"};